import { Bell } from "lucide-react";

const NoNotifications = () => (
  <div className="flex flex-col items-center justify-center px-6 py-12">
    <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-xl bg-gray-50/80 transition-all duration-300 hover:scale-105 hover:bg-gray-100/80 dark:bg-gray-800/50 dark:hover:bg-gray-800">
      <Bell className="h-6 w-6 text-gray-300 dark:text-gray-600" strokeWidth={1.5} />
    </div>
    <h3 className="mb-1.5 text-[13px] font-medium text-gray-700 dark:text-gray-300">
      No notifications
    </h3>
    <p className="text-center text-[12px] leading-relaxed text-gray-400 dark:text-gray-500">
      You're all caught up! We'll notify you when something new arrives.
    </p>
  </div>
);

export default NoNotifications;
